<template>
    <div class="profile-details">
        <form>
            <input
                v-if="isDataLoaded"
                type="hidden"
                name="id"
                :value="client.id"
            />
        </form>
        <b-row class="skeleton" v-if="!isDataLoaded || isBusinessLoading">
            <b-col md="2" class="image">
                <div></div>
            </b-col>
            <b-col md="3" class="content">
                <div></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div class="smaller"></div>
            </b-col>
            <b-col md="3" class="content">
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
            <b-col md="3" class="content">
                <div class="smaller"></div>
                <div class="smaller"></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
        </b-row>

        <b-row v-if="isDataLoaded && !isBusinessLoading">
            <b-col lg="5">
                <b-row>
                    <b-col sm="5">
                        <client-photo :client="client" v-on="$listeners" />
                    </b-col>
                    <b-col sm="7">
                        <b-table-simple borderless>
                            <b-tbody>
                                <b-tr>
                                    <b-th>First Name:</b-th>
                                    <b-td>
                                        <span>{{ client.firstname }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th class="w-50">Last Name:</b-th>
                                    <b-td>
                                        <span>{{ client.lastname }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Address:</b-th>
                                    <b-td>
                                        <span>{{ client.address }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Zipcode:</b-th>
                                    <b-td>
                                        <span>{{ client.zipcode }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>City:</b-th>
                                    <b-td>
                                        <span>{{ client.city }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>County:</b-th>
                                    <b-td>
                                        <span>{{ client.county }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>State:</b-th>
                                    <b-td>
                                        <span>{{ client.state }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Country:</b-th>
                                    <b-td>
                                        <span>{{ client.country }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Birthdate:</b-th>
                                    <b-td>
                                        <span>{{
                                            _reformatDateDisplay(
                                                client.birthdate
                                            )
                                        }}</span>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="7">
                <b-row>
                    <b-col sm="5" lg="6">
                        <b-table-simple borderless>
                            <b-tbody>
                                <b-tr>
                                    <b-th>Home:</b-th>
                                    <b-td>
                                        <a
                                            :href="'tel:' + client.home"
                                            data-rel="external"
                                            >{{ client.home }}
                                        </a>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Mobile:</b-th>
                                    <b-td>
                                        <a
                                            :href="'tel:' + client.mobile"
                                            data-rel="external"
                                            >{{ client.mobile }}
                                        </a>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Work:</b-th>
                                    <b-td>
                                        <a
                                            :href="'tel:' + client.work"
                                            data-rel="external"
                                            >{{ client.work }}
                                        </a>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Fax:</b-th>
                                    <b-td>
                                        <a
                                            :href="'tel:' + client.fax"
                                            data-rel="external"
                                            >{{ client.fax }}
                                        </a>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Email:</b-th>
                                    <b-td>
                                        <span>{{ client.email }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Reminders:</b-th>
                                    <b-td>
                                        <span v-if="client.reminderOptions">
                                            {{ listReminders() }}
                                        </span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Driver License:</b-th>
                                    <b-td>
                                        <span>{{ client.driver_license }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Referred By:</b-th>
                                    <b-td>
                                        <div v-if="client.referral">
                                            <b-link
                                                v-if="
                                                    client.referral.type == 0 &&
                                                    client.referral
                                                        .relation_type.id == 4
                                                "
                                                :to="{
                                                    name: 'client_profile',
                                                    params: {
                                                        id:
                                                            client.referral
                                                                .encoded_id
                                                    }
                                                }"
                                            >
                                                {{ client.referral.firstname }}
                                                {{ client.referral.lastname }}
                                            </b-link>
                                            <a
                                                v-else-if="
                                                    client.referral.type == 0 &&
                                                    client.referral
                                                        .relation_type.id == 14
                                                "
                                                :href="
                                                    client.referral
                                                        .ci_contact_url
                                                "
                                            >
                                                {{
                                                    client.referral.display_name
                                                }}
                                            </a>
                                            <a
                                                v-else-if="
                                                    client.referral.type == 1
                                                "
                                                :href="
                                                    client.referral
                                                        .ci_contact_url
                                                "
                                            >
                                                {{ client.referral.name }}
                                            </a>
                                            <span
                                                v-else-if="
                                                    client.referral.type == 2
                                                "
                                            >
                                                {{ client.referral.title }}
                                            </span>
                                        </div>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                    <b-col sm="7" lg="6">
                        <b-table-simple borderless>
                            <b-tbody>
                                <b-tr>
                                    <b-th>Balance:</b-th>
                                    <b-td v-if="currencySymbol">
                                        <span v-if="client.account_balance">{{
                                            _toCurrency(client.account_balance)
                                        }}</span>
                                        <span v-else>{{ _toCurrency(0) }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr
                                    v-if="
                                        client.shared_account_balance.length > 0
                                    "
                                >
                                    <b-th></b-th>
                                    <b-td>
                                        <strong
                                            class="text-primary cursor-pointer"
                                            @click="
                                                openAccountListModal(
                                                    client.shared_account_balance
                                                )
                                            "
                                        >
                                            {{ recordSharingBalance }} ({{
                                                client.shared_account_balance
                                                    .length
                                            }}
                                            clinics)</strong
                                        >
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Payment Terms:</b-th>
                                    <b-td>
                                        <span>{{ client.paymentTerm }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Exempt From:</b-th>
                                    <b-td>
                                        {{
                                            listExemptions(client.exemptOptions)
                                        }}
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Status:</b-th>
                                    <b-td>
                                        <span v-if="client.status.id == 1"
                                            >Active</span
                                        >
                                        <span v-if="client.status.id == 2"
                                            >Inactive ({{
                                                client.status.status_date
                                                    | secondsToDate
                                            }})</span
                                        >
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Discounts:</b-th>
                                    <b-td>
                                        <span>{{
                                            getDiscountDisplay(client.discount)
                                        }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr v-if="client.isRecordSharing">
                                    <b-th>Home Location:</b-th>
                                    <b-td>
                                        <span>{{
                                            client.homeLocationName
                                        }}</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Last Visit:</b-th>
                                    <b-td>
                                        <strong
                                            v-if="client.lastVisit"
                                            class="text-primary cursor-pointer"
                                            @click="
                                                goToAppointment(
                                                    client.lastVisit
                                                )
                                            "
                                        >
                                            {{
                                                _setDateTimeDisplay(
                                                    client.lastVisit
                                                )
                                            }}
                                        </strong>
                                        <span v-else>Not scheduled</span>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>Next Visit:</b-th>
                                    <b-td>
                                        <strong
                                            v-if="client.nextVisit"
                                            class="text-primary cursor-pointer"
                                            @click="
                                                goToAppointment(
                                                    client.nextVisit
                                                )
                                            "
                                        >
                                            {{
                                                _setDateTimeDisplay(
                                                    client.nextVisit
                                                )
                                            }}
                                        </strong>
                                        <span v-else>Not scheduled</span>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <record-balance-list-modal ref="modalRecordBalanceList" />
    </div>
</template>
<script>
import _ from "lodash";
import ClientPhoto from "@/components/client-photos/photo-display";
import RecordBalanceListModal from "@/components/client-details/record-sharing-balance-list";

export default {
    components: {
        ClientPhoto,
        RecordBalanceListModal
    },
    data() {
        return {
            isShowPopover: true
        };
    },
    computed: {
        client() {
            return this.$store.state.client.client_details;
        },
        currencySymbol() {
            return this.$store.getters["currency"];
        },
        recordSharingBalance() {
            return this._toCurrency(
                this.client.shared_account_balance.reduce(
                    (value, data) => value + data.account_balance,
                    0
                )
            );
        },
        isDataLoaded() {
            return !_.isEmpty(this.$store.state.client.client_details);
        },
        isBusinessLoading() {
            return this.$store.getters["isBusinessLoading"];
        }
    },
    methods: {
        openAccountListModal(arrayOfClinics) {
            this.$refs.modalRecordBalanceList.open(arrayOfClinics);
        },
        listExemptions(exemptions) {
            let list = "No exemptions";

            if (exemptions) {
                if (exemptions.length > 0) {
                    list = "";

                    exemptions.forEach((element, i) => {
                        if (i != 0) {
                            list += ", ";
                        }
                        list += element.value;
                    });
                }
            }

            return list;
        },
        goToAppointment(date) {
            let formatted = this.$options.filters.isoDateToSeconds(date);
            this.$router.push({
                name: "appointment",
                params: { view: "resourceTimeGridDay", start: formatted }
            });
        },
        getDiscountDisplay(discount) {
            let display = "No Discount";

            if (discount) {
                display = discount.name;
                if (discount.all_category == 1) {
                    if (discount.type === 0) {
                        display += " (" + discount.amount + "%)";
                    } else {
                        display += " ($" + discount.amount + ")";
                    }
                }
            }

            return display;
        },
        listReminders() {
            let reminders = "Client opted out";
            let text = "";
            let options = this.client.reminderOptions;

            if (options.length > 0) {
                reminders = "";

                options.forEach((e, i) => {
                    if (i != 0) {
                        reminders = reminders + ", ";
                    }

                    switch (Number(e)) {
                        case 1:
                            text = "Email";
                            break;
                        case 2:
                            text = "Phone";
                            break;
                        case 3:
                            text = "Mail";
                            break;
                        case 4:
                            text = "No Reminder";
                            break;
                        case 5:
                            text = "SMS (Text)";
                            break;
                        default:
                            text = "";
                    }

                    reminders = reminders + text;
                });
            }

            return reminders;
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.profile-details table tbody tr td:first-child {
    font-weight: bold;
}

.profile-details .table th,
.profile-details .table td {
    padding: 0px;
    line-height: 35px;
}
</style>
